import axios from './axios';
import SETTINGS from '../settings'
export default {
    getLeaderboards(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/quizleaderboard`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getLeaderboard(id, params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/quizleaderboard/${id}`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}